import { Transition } from '@uirouter/core';
import { ResetPasswordController } from './reset-password.controller';
import { StateProvider, UrlRouterProvider } from '@uirouter/angularjs';
import { registerComponentFromTransition } from "../core/lazy-route.helper";
import { RESET_PASSWORD_COMPONENT } from './reset-password.component';

import './reset-password.html';


export function configRoute($stateProvider: StateProvider, $urlRouterProvider: UrlRouterProvider) {

    $stateProvider.state("resetPassword", {
        url: "/reset-password?username&id&ticket",
        component: RESET_PASSWORD_COMPONENT,
        resolve: {
            "userAndTicket": ["$transition$", (transition: Transition) => transition.params<{ username: string, id: string, ticket: string }>()]
        },
        bindings: {
            userAndTicket: "userAndTicket"
        },
        lazyLoad: async (transition, state) => {
            const moduleExports: any = await import("./reset-password.component");
            registerComponentFromTransition(transition, RESET_PASSWORD_COMPONENT, moduleExports.resetPasswordComponentOptions);
            return moduleExports;
        }
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];


// WEBPACK FOOTER //
// ./app/reset-password/reset-password.router.ts